export default __webpack_public_path__ + "static/media/IMG_1936.6c86833f.jpeg";